<template>
  <div>
    <MasterLayout>
      <!-- LOADER -->
      <section
        class="row card-loader-wrapper ml-1"
        style="width: 98%"
        v-if="showLoader"
      >
        <div
          class="col-md-3 position-relative mb-2"
          v-for="(c, i) in 4"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
      </section>
      <!-- END LOADER -->
      <section class="mt-3 full__row_section" v-if="!showLoader">
        <div class="dashboard__cards__wrapper">
          <div class="dashboard__card small_card">
            <div class="small__card_content_wrapper">
              <h4
                style="font-size: 13px; font-weight: bold"
                class="dashboard__card__header"
              >
                {{ $t("text.iDashboard.powerHours") }}
              </h4>
              <div class="car_content_flex_wrapper mt-1">
                <img src="@/assets/img/042-electric_tower.svg" width="40px" />
              </div>
              <div class="mt-3 pb-3">
                <h3 class="dashboard__card__header_bottom">
                  {{ powerHour }}
                </h3>
              </div>
            </div>
          </div>

          <div class="dashboard__card small_card">
            <div class="small__card_content_wrapper">
              <h4
                style="font-size: 13px; font-weight: bold"
                class="dashboard__card__header"
              >
                {{ $t("text.iDashboard.totalHoursOnGenGrid") }}
              </h4>
              <div class="car_content_flex_wrapper mt-1">
                <img src="@/assets/img/002-energy.svg" width="40px" />
              </div>
              <div class="mt-3 pb-3">
                <h3 class="dashboard__card__header_bottom">
                  {{ generatorHour }}
                </h3>
              </div>
            </div>
          </div>

          <!-- VOLUME CONSUMED -->
          <div class="dashboard__card small_card">
            <div class="small__card_content_wrapper">
              <h4
                style="font-size: 13px; font-weight: bold"
                class="dashboard__card__header"
              >
                {{ $t("text.iDashboard.totalConsumedToday") }}
              </h4>
              <div class="car_content_flex_wrapper mt-1">
                <img src="@/assets/img/002-energy.svg" width="40px" />
              </div>
              <div class="mt-3 pb-3">
                <h3 class="dashboard__card__header_bottom">
                  {{ totalVolumeSold }} {{ $t("text.iDashboard.litres") }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="dashboard__card large_card indus_back_img"
            :style="[
              {
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              },
            ]"
          >
            <div class="row align-items-center larg_inner__row">
              <div class="col-md-4 larg_inner__row_left">
                <img src="@/assets/img/money (3).svg" width="70" />
              </div>
              <div class="col-md-8 larg_inner__row_right">
                <div>
                  <small class="text-white">{{
                    $t("text.iDashboard.walletBalance")
                  }}</small>
                </div>
                <h5 class="text-white mt-4">
                  {{ industryBranch ? industryBranch.currencyCode : "" }}
                  {{ walletBalance }}
                </h5>
                <div class="mt-4">
                  <router-link
                    :to="{
                      name: 'industrialBranchFundWallet',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: this.$route.query.companyId,
                        groupId: this.$route.query.groupId,
                      },
                    }"
                    class="vue_router_link btn btn_primary"
                  >
                    {{ $t("text.iDashboard.addFunds") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-3 full__row_section">
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full"
          style="width: 100%; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
        <div class="row dashboard_second_row" v-if="!showLoader">
          <div class="col-md-4">
            <div class="product_slider">
              <vueper-slides
                class="no-shadow"
                :visible-slides="1"
                slide-multiple
                :gap="0"
                :slide-ratio="1 / 4"
                :dragging-distance="200"
                :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
              >
                <vueper-slide
                  v-for="(tank, index) in tanks"
                  :key="index"
                  style="
                    display: block !important;
                    padding-right: 0;
                    padding-left: 0;
                  "
                >
                  <template v-slot:content>
                    <div class="low_tank text-center" style="box-shadow: none">
                      <h4 class="tank__name__header">{{ tank.name }}</h4>
                      <p style="margin-bottom: 0 !important" class="max-lines">
                        {{ tank.lastSeen }}
                      </p>
                      <span> </span>
                      <div class="animated__tanks__div">
                        <div class="bowl" style="margin-left: 27%">
                          <div class="inner">
                            <div
                              class="fill"
                              v-bind:style="{
                                '--h': tank.height + 'px',
                                '--c': tank.waveColor,
                              }"
                            >
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="10px"
                                y="20px"
                                width="300px"
                                height="300px"
                                viewBox="0 0 300 300"
                                enable-background="new 0 0 300 300"
                                xml:space="preserve"
                              >
                                <path
                                  class="waveShape"
                                  d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                                                    c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                                                    c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="clearfix mt-3"
                      style="width: 70%; margin: 0 auto"
                    >
                      <div class="left_div">
                        <span class="left"
                          >{{ $t("text.iDashboard.currentVolume") }}:</span
                        >
                      </div>
                      <div class="right_div">
                        <span class="tank__header__text">
                          {{ convertThousand(tank.currentVolume) }} ({{
                            tank.percent
                          }}%)
                        </span>
                      </div>
                    </div>
                    <div
                      class="clearfix mt-2"
                      style="width: 70%; margin: 0 auto"
                    >
                      <div class="left_div">
                        <span class="left"
                          >{{ $t("text.iDashboard.maxCapacity") }}:</span
                        >
                      </div>
                      <div class="right_div">
                        <span class="tank__header__text">
                          {{ convertThousand(tank.maxCapacity) }}
                        </span>
                      </div>
                    </div>

                    <div
                      class="clearfix pb-4 mt-2"
                      style="width: 70%; margin: 0 auto"
                    >
                      <div class="left_div">
                        <span class="left">{{
                          $t("text.iDashboard.waterVol")
                        }}</span>
                      </div>
                      <div class="right_div">
                        <span class="tank__header__text">
                          {{ convertThousand(tank.waterVolume) }}
                        </span>
                      </div>
                    </div>
                  </template>
                </vueper-slide>
              </vueper-slides>
            </div>

            <!-- ORDER FUEL -->
            <div
              class="order_card mt-3"
              style="border-bottom: 4px solid #370f70"
            >
              <div class="small__card_content_wrapper">
                <h4
                  class="dashboard__card__header order__text mt-3 font-weight-bolder"
                >
                  {{ $t("text.iDashboard.orderFor") }}
                </h4>
                <div class="car_content_flex_wrapper mt-3">
                  <img src="@/assets/img/Vector.svg" width="40px" />
                </div>
                <div class="mt-2 pb-3">
                  <router-link
                    :disabled="isDisabled"
                    :to="{
                      name: 'IndusrialBranchAddOrder',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: this.$route.query.companyId,
                        groupId: this.$route.query.groupId,
                      },
                    }"
                    class="vue_router_link btn btn_theme text-white"
                    style="background-color: #370f70 !important"
                  >
                    {{ $t("text.iDashboard.order") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 dashboard_second_row_right">
            <div class="dashboard_chart">
              <div class="row pt-4">
                <div class="col-md-8">
                  <div
                    v-show="consumptionstatus === 'daily'"
                    class="ml-3"
                    style="width: 300px"
                  >
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                  <!-- <div v-show="consumptionstatus === 'hourly'">
                    <vue-ctk-date-time-picker
                      id="fourth_date_picker"
                      v-model="hourlyPoweerConsumptionDateRange"
                      :max-date="maxDate"
                      :onlyDate="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.selectDate')"
                    />
                  </div>
                  <div v-show="consumptionstatus === 'monthly'">
                    <div
                      class="
                        input__block input_width_shrink
                        remove_input_border_color
                      "
                      style="color: grey"
                    >
                      <select v-model="year" @change="changeYear">
                        <option value="2020">2020</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                        <option value="2017">2017</option>
                        <option value="2016">2016</option>
                        <option value="2015">2015</option>
                        <option value="2014">2014</option>
                      </select>
                    </div>
                  </div> -->
                </div>

                <div class="col-md-4 mt-1">
                  <h5>{{ $t("text.iDashboard.dailyUsage") }}</h5>

                  <!-- <div
                    class="
                      input__block input_width_shrink
                      remove_input_border_color
                    "
                  >
                  
                    <select
                      v-model="consumptionstatus"
                      @change="changeConsumptionStatus"
                    >
                      <option value="daily">
                        {{ $t("text.iDashboard.dailyUsage") }}
                      </option>
                      <option value="monthly">
                        {{ $t("text.iDashboard.monthlyUsage") }}
                      </option>
                    </select>
                  </div> -->
                </div>
              </div>
              <div v-show="consumptionstatus === 'daily'">
                <highcharts
                  :options="dailyUsageChart"
                  class=""
                  style="padding-top: 60px"
                ></highcharts>
              </div>
              <div v-show="consumptionstatus === 'hourly'">
                <highcharts
                  :options="hourlyUsageChart"
                  class=""
                  style="padding-top: 60px"
                ></highcharts>
              </div>
              <!-- <div v-show="consumptionstatus === 'monthly'">
                <highcharts
                  :options="monthyChart"
                  class=""
                  style="padding-top: 60px"
                ></highcharts>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section class="full__row_section mt-3 pb-3" v-if="!showLoader">
        <div class="charts_wrapper">
          <div
            class="col-md-12 section___column_2"
            style="background-color: white"
          >
            <div class="align-items-center">
              <div class="">
                <div class="drop_down_section mt-2 mr-5">
                  <div
                    class="drop_down_div align-items-center"
                    style="border-bottom: 1px solid grey"
                  >
                    <vue-ctk-date-time-picker
                      id="third_date_picker"
                      v-model="tankDateRange"
                      :max-date="maxDate"
                      :onlyDate="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.selectDate')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <highcharts
            :options="tankDisplacementChart"
            class="mt-3"
            style=""
          ></highcharts>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
  },
  data() {
    return {
      linkQuery: {
        branchId: this.$route.query.branchId,
        companyId: this.$route.query.companyId,
        groupId: this.$route.query.groupId,
      },
      showLoader: true,
      isDisabled: true,
      tankStartDate: this.$moment().format("MMMM D, YYYY"),
      hourlyConsumptionStartDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
      },

      tankDateRange: this.$moment().format("D-M-YYYY"),
      hourlyPoweerConsumptionDateRange: this.hourlyConsumptionStartDate,
      totalGenHours: 0,
      totalPgHours: 0,
      powerHour: 0,
      generatorHour: 0,
      tanks: [],
      powerHoursConsumedDateRange: {
        start: this.powerHoursConsumedStartDate,
        end: this.powerHoursConsumedEndDate,
      },
      powerHoursConsumedEndDate: this.$moment().format("MMMM D, YYYY"),
      powerHoursConsumedStartDate: this.$moment().format("MMMM D, YYYY"),
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      totalVolumeSold: 0,
      tankSale: { pms: 0, ago: 0, dpk: 0, lpg: 0 },
      tankSaleStartDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      tankSalesEndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      walletTransactionStartDate: this.$moment()
        .subtract(30, "days")
        .format("D-M-YYYY"),
      walletTransactionEndDate: this.$moment().format("D-M-YYYY"),
      pluginStartDate: this.$moment(new Date()).format("D-M-YYYY"),
      tankDisplacementStartDate: this.$moment().format("D-M-YYYY"),
      hourlyPowerConsumedStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().subtract(400, "days").format("D-M-YYYY"),
      powerSource: "",
      industryBranch: null,
      industryBranchId: null,
      walletBalance: 0,
      consumptionstatus: "daily",
      year: "2020",
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      dailyUsageChart: {
        title: false,
        chart: {
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.dailyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
      hourlyUsageChart: {
        title: false,
        chart: {
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.hourlyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
      monthyUsageChart: {
        title: false,
        chart: {
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.monthlyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
      tankDisplacementChart: {
        chart: {
          type: "spline",
        },
        title: {
          text: this.$t("text.iDashboard.totalTankDisplacement"),
        },
        subtitle: {},
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.totalTankDisplacementLitres"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
    };
  },
  created() {
    //   this.tankDateRange = this.tankDisplacementStartDate;
    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;
    this.hourlyPoweerConsumptionDateRange = this.hourlyPowerConsumedStartDate;
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    tankDateRange: function (newDate) {
      if (newDate) {
        this.tankStartDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTanksProbeByHour();
      }
    },
    hourlyPoweerConsumptionDateRange: function (newDate) {
      if (newDate) {
        this.hourlyConsumptionStartDate = this.$moment(
          newDate,
          "DD-MM-YYYY"
        ).format("MMMM D, YYYY");
      }
    },

    powerHoursConsumedDateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.powerHoursConsumedStartDate = this.$moment(
          newRange.start,
          "DD-MM-YYYY"
        ).format("MMMM D, YYYY");
        this.powerHoursConsumedEndDate = this.$moment(
          newRange.end,
          "DD-MM-YYYY"
        ).format("MMMM D, YYYY");

        this.getPowerUseDetails();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getPowerUseDailyUsage();
      }
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getPowerUseDetails();
        this.getPowerUseDailyUsage();
        this.getTanks();

        this.getTankSales();
        this.getTanksProbeByHour();
        this.getWalletBalance();
        this.getHours();
        this.getMonthlyUsageChart();
      }
    },
  },
  mounted() {
    // this.getWalletBalance();
  },
  computed: {
    walletStartDate() {
      return this.$moment(this.walletTransactionStartDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
    walletEndDate() {
      return this.$moment(this.walletTransactionEndDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
  },
  methods: {
    changeConsumptionStatus(e) {
      if (e.target.value === "hourly") {
        this.consumptionstatus = "hourly";
      } else if (e.target.value === "daily") {
        this.consumptionstatus = "daily";
      } else {
        this.consumptionstatus = "monthly";
      }
    },
    changeYear(e) {
      this.year = e.target.value;
      this.getMonthlyUsageChart();
    },

    getTankSales() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TotalTankSales/${this.industryBranch.id}?startDate=${this.tankSaleStartDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          // const totalVolumeSold = res.data.reduce((acc, cur) => {
          //   return (acc += cur.volumeSold);
          // }, 0);
          // this.totalVolumeSold = this.convertThousand(totalVolumeSold);
          //  console.log(this.totalVolumeSold)
          this.totalVolumeSold = this.convertThousand(
            res.data.totalVolumeConsumed
          );
        })
        .catch((error) => {});
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getHours() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUse/${this.industryBranch.id}?startDate=${this.powerHoursConsumedStartDate}&endDate=${this.powerHoursConsumedEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.map((type) => {
            if (type.source === "Power Grid") {
              this.powerHour = type.usageTime;
            }
            if (type.source === "Generator") {
              this.generatorHour = type.usageTime;
            }
          });
        })
        .catch((error) => {});
    },
    getWalletBalance() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/branchremiswallet/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.walletBalance = this.convertThousand(res.data.balance);
        })
        .catch((error) => {});
    },
    getTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Tanks/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((element) => {
            if (element.currentVolume > 0 && element.maxCapacity > 0) {
              element.percent = (
                (element.currentVolume / element.maxCapacity) *
                100
              ).toFixed(1);
            } else {
              element.percent = 0;
            }
            element.height = parseInt(
              150 - (element.currentVolume / element.maxCapacity) * 140
            );
            if (element.percent < 30) {
              element.waveColor = "red";
            } else if (element.percent > 30 && element.percent < 50) {
              element.waveColor = "blue";
            } else if (element.percent > 50) {
              element.waveColor = "green";
            } else {
              element.waveColor = "lightblue";
            }

            element.waterVolume =
              element.waterVolume == null ? 0 : element.waterVolume;
            if (
              element.productName !== undefined &&
              element.productName !== null
            ) {
              if (element.productName.toLowerCase() === "pms") {
                element.color = "#d8991c";
              } else if (element.productName.toLowerCase() === "ago") {
                element.color = "#0fce29";
              } else if (element.productName.toLowerCase() === "dpk") {
                element.color = "#00aced";
              }
            } else if (element.name !== undefined && element.name !== null) {
              if (element.name.toLowerCase().includes("pms")) {
                element.color = "#d8991c";
              } else if (element.name.toLowerCase().includes("ago")) {
                element.color = "#0fce29";
              } else if (element.name.toLowerCase().includes("dpk")) {
                element.color = "#00aced";
              }
            }
          });

          response.data.sort(function (a, b) {
            return a.height - b.height;
          });

          this.tanks = response.data;

          //  console.log(this.tank);
        })
        .catch((error) => {});
    },
    getPowerUseDailyUsage() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseDaily/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((x) => {
            let date = new Date(x.date);
            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
          });
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let vol = res.data.filter((el) => el.source === "Volume Use");
          let genArr = [];
          let powerArr = [];
          let volArr = [];
          let cats = [];

          gen.forEach((el) => {
            const newArr = el.hours.toFixed(2);
            // console.log(`gen array - ${newArr}`);
            genArr.push(parseFloat(newArr));
            cats.push(el.date);
          });
          let genSeries = [
            {
              name: this.$t("text.iReport.generator"),
              data: genArr,
              color: "#FCD462",
            },
          ];
          powerGrid.forEach((el) => {
            const newArrs = el.hours.toFixed(2);
            // console.log(`power array - ${newArrs}`);
            // console.log(newArrs)
            powerArr.push(parseFloat(newArrs));
          });
          let powerSeries = [
            {
              name: this.$t("text.iReport.powerGrid"),
              data: powerArr,
              color: "#370F70",
            },
          ];
          vol.forEach((el) => {
            if (el.hours < 0) {
              el.hours = 0;
            }
            const newArrz = el.hours.toFixed(2);
            // console.log(`vol array - ${newArrz}`);
            volArr.push(parseFloat(newArrz));
          });
          let volSeries = [
            {
              name: this.$t("text.iReport.volUsed"),
              data: volArr,
              color: "red",
            },
          ];

          this.dailyUsageChart.series = [
            // ...volSeries,
            ...genSeries,
            ...powerSeries,
          ];
          this.dailyUsageChart.xAxis.categories = cats;
        })
        .catch((error) => {});
    },
    getHourlyUsageChart() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseHourly/${this.industryBranch.id}?Date=${this.hourlyConsumptionStartDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          const copiedRes = res.data;
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let genArr = [];
          let powerArr = [];

          gen.forEach((el) => {
            genArr.push(el.hours);
          });
          let genSeries = [
            {
              name: "Generator",
              data: genArr,
              color: "#FCD462",
            },
          ];
          powerGrid.forEach((el) => {
            powerArr.push(el.hours);
          });
          let powerSeries = [
            {
              name: "Power Grid",
              data: powerArr,
              color: "#370F70",
            },
          ];

          const timeCats = [
            ...new Set(
              copiedRes.map((x) => this.$moment(x.date).format("h:mm A"))
            ),
          ];
          this.hourlyUsageChart.xAxis.categories = timeCats;
          this.hourlyUsageChart.series = [...genSeries, ...powerSeries];
        })
        .catch((error) => {});
    },
    getMonthlyUsageChart() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseMonthly/${this.industryBranch.id}/${this.year}`,
          configObject.authConfig()
        )
        .then((res) => {
          const copiedRes = res.data;
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let genArr = [];
          let powerArr = [];
          let cats = [];

          gen.forEach((el) => {
            genArr.push(el.hours);
            cats.push(el.month);
          });
          let genSeries = [
            {
              name: "Generator",
              data: genArr,
              color: "#FCD462",
            },
          ];
          powerGrid.forEach((el) => {
            powerArr.push(el.hours);
          });
          let powerSeries = [
            {
              name: "Power Grid",
              data: powerArr,
              color: "#370F70",
            },
          ];
          this.monthyUsageChart.xAxis.categories = cats;
          this.monthyUsageChart.series = [...genSeries, ...powerSeries];
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getPowerUseDetails() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUse/${this.industryBranch.id}?startDate=${this.powerHoursConsumedStartDate}&endDate=${this.powerHoursConsumedEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let genArr = [];
          let pgArr = [];

          res.data.forEach((el, i) => {
            if (el.source === "Power Grid") {
              pgArr.push(el);
            } else if (el.source === "Generator") {
              genArr.push(el);
            }
          });
          const totalPgHours = pgArr.reduce((acc, cur) => {
            if (typeof cur.hours === "number") {
              return acc + cur.hours;
            } else {
              return acc + 0;
            }
          }, 0);
          const totalGenHours = genArr.reduce((acc, cur) => {
            return acc + cur.hours;
          }, 0);
          this.totalPgHours = totalPgHours
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.totalGenHours = totalGenHours
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch((error) => {});
    },

    getTanksProbeByHour() {
      //console.log(this.industryBranch.id);
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/TanksHourlyProbe/${this.industryBranch.id}?date=${this.tankStartDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          if (response.data.length > 0) {
            const ids = new Set(response.data.map((cur) => cur.tankName));
            let splineData = response.data;
            let series = [];
            splineData.forEach((cur) => {
              let volume = cur.productVolume.toFixed(2);
              ids.forEach((current) => {
                const index = series.findIndex((sery) => sery.name == current);
                if (index == -1 && cur.tankName == current) {
                  series.push({
                    name: current,
                    data: [cur.productVolume],
                  });
                }
                if (index != -1 && cur.tankName == current) {
                  const value = series[index].data;
                  series[index].data = [...value, cur.productVolume];
                }
              });
            });
            series.forEach((cur) => {
              let newData = cur.data.map((val) => Number(val.toFixed(2)));
              cur.data = newData.reverse();
            });

            series.sort((a, b) =>
              a.name.toLowerCase() < b.name.toLowerCase()
                ? -1
                : a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : 0
            );

            const timeCats = [
              ...new Set(
                splineData.map((x) => this.$moment(x.date).format("h:mm A"))
              ),
            ];
            this.tankDisplacementChart.xAxis.categories = timeCats.reverse();
            this.tankDisplacementChart.series = series;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
